import { Component, Input, OnInit } from '@angular/core';
import { CurrentAuctionList } from '../../../../models/auctionList';
import constants from '../../../../utility/constants';
import { AuthenticationService } from '../../../../services';
import { Router } from '@angular/router';
import routeTable from '../../../../utility/routeTable';
import { AuctionTimeService } from '../../../../services/auction-time.service';

@Component({
  selector: 'auction-card',
  templateUrl: './auction-card.component.html',
  styleUrls: ['./auction-card.component.css'],
})
export class AuctionCardComponent implements OnInit {
  @Input('listView') showListView: boolean = false;
  @Input('auctionData') data: CurrentAuctionList;
  @Input('routeType') routeType: string | null;

  showView: boolean = false;
  isLoggedIn: boolean | null;
  routes = routeTable.public;

  registrationFormats = constants.common.saletypeRegistrationFormat;
  auctionStatuses = constants.common.auctionStatus;

  isBiddingOpen: boolean = false;
  isClosingToday: boolean = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private auctionTimeService: AuctionTimeService
  ) {
    this.isLoggedIn = this.authService.checkLoggedIn();
  }

  ngOnInit() {
    this.showView = true;
    this.checkBiddingOpen();
    this.checkAuctionCLosingToday();
  }

  private checkBiddingOpen() {
    if (
      this.data.auctionStatus === this.auctionStatuses.live &&
      !this.data.saleType.isCatalogReadOnly
    ) {
      this.isBiddingOpen = this.auctionTimeService.isBiddingOpen(
        this.data.startDateTimeUtc,
        this.data.lastEndDateTimeUtc
      );
    }
  }

  private checkAuctionCLosingToday() {
    if (
      this.data.auctionStatus === this.auctionStatuses.live &&
      !this.data.saleType.isCatalogReadOnly
    ) {
      this.isClosingToday = this.auctionTimeService.isAuctionClosingToday(
        this.data.lastEndDateTimeUtc
      );
    }
  }

  getButtonText(data: any) {
    if (!data.saleType.isCatalogUploadAllowed && this.isWithinTimeRange(data.startDateTime, data.endDateTime)) {
      return "Bid Now"
    }
    return "Lot Catalog"
  }

  isWithinTimeRange(startDateTime, endDateTime) {
    const startTime = new Date(startDateTime);
    const endTime = new Date(endDateTime);
  
    // Add 12 hours to the end time
    const extendedEndTime = new Date(endTime.getTime() + 12 * 60 * 60 * 1000);
  
    const currentTime = new Date();
  
    return currentTime > startTime && currentTime < extendedEndTime;
  }

  goToRegister(auctionCode: string) {
    this.router.navigate([auctionCode, routeTable.public.auctionRegister], {
      queryParams: { returnTo: this.router.url },
    });
  }

  goToLots(auctionCode: string) {
    this.router.navigate([auctionCode, routeTable.public.auctionLot], {
      queryParams: { returnTo: this.router.url },
    });
  }

  goToViewDetailHref(auctionCode: string): string {
    if (this.data.saleType.isDetailPageInHouse) {
      const returnUrl = encodeURIComponent(this.router.url);
      return `/${auctionCode}?returnTo=${returnUrl}`;
    } else {
      return this.data.detailPageLinkUrl;
    }
  }

  goToViewDetail(auctionCode: string) {
    if (this.data.saleType.isDetailPageInHouse) {
      this.router.navigate([auctionCode], {
        queryParams: { returnTo: this.router.url },
      });
    } else {
      window.location.href = this.data.detailPageLinkUrl;
    }
  }

  goToInquire(auctionCode: string) {
    this.router.navigate(['/', auctionCode, this.routes.enquire], {
      queryParams: { returnTo: this.router.url },
    });
  }
}
